import { ListWrapperStyled as ListWrapper } from './index.styles';

export default ListWrapper;
